import * as core from '../../../../../../../core'
import * as organizationHealthCheck from '../organization-health-check'

export const RESOURCE = {
  payload: {
    alias: 'details',
    appAlias: organizationHealthCheck.RESOURCE.payload.alias,
    description:
      'Shows details of a specific Track for a given organizational health check assessment.',
    display: {
      isMain: false,
      position: 2,
    },
    name: 'Details',
    page: { alias: 'details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
